import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { YearService } from './year-service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-year',
  standalone: true,
  imports: [CommonModule, FormsModule,MatIconModule],
  templateUrl: './year.html',
  styleUrls: ['./year.scss']
})
export class Year implements OnInit {
  searchText: string = '';
  years: { title: string }[] = [];
  selectedMake: string = '';
  selectedModel: string = '';
  selectedData: string = '';
  loading: boolean = false;

  constructor(
    private yearService: YearService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loading = true;

    // Get selected make
    if (localStorage.getItem('newMake'))
      this.selectedMake = localStorage.getItem('newMake')!;
    else
      this.selectedMake = localStorage.getItem('selectedMake')!;

    // Get selected model
    if (localStorage.getItem('newModel'))
      this.selectedModel = localStorage.getItem('newModel')!;
    else
      this.selectedModel = localStorage.getItem('selectedModel')!;

    // Fetch year data
    this.getYearData();

    // Selected year
    if (localStorage.getItem('selectedYear')) {
      this.selectedData = localStorage.getItem('selectedYear')!;
    }
  }

  getYearData() {
  const result = this.yearService.getYear();
  this.loading = false;

  if (!result) {
    console.warn('No data found in sessionStorage');
    return;
  }

  try {
    const res = JSON.parse(result);

    const makeParts = this.selectedMake.split(' - ');
    const brand = makeParts[0].trim();
    const modelParts = this.selectedModel.split(' - ');
    const model = modelParts.length > 1 ? modelParts[1].trim() : modelParts[0].trim();

    if (!res.data[brand]) {
      console.error('Make not found in data:', brand);
      return;
    }

    res.data[brand].forEach((list: any) => {
      if (list['model'] === model) {
        // Always update rowKey
        localStorage.setItem('rowKey', list['rowKey']);

        // Populate years
        const yearTo = list['yearTo'] || new Date().getFullYear();
        for (let i = list['yearFrom']; i <= yearTo; i++) {
          this.years.push({ title: i.toString() });
        }
      }
    });

    this.cdr.detectChanges();

  } catch (e) {
    console.error('Error parsing result:', e);
  }
}


  get filteredYears() {
    if (!this.searchText.trim()) return this.years;
    return this.years.filter(year =>
      year.title.includes(this.searchText.trim())
    );
  }

  clearSearch() {
    this.searchText = '';
  }

  selectYear(year: { title: string }) {
    if (
      localStorage.getItem('selectedMake') &&
      localStorage.getItem('selectedModel') &&
      localStorage.getItem('selectedYear') &&
      localStorage.getItem('variant')
    ) {
      localStorage.setItem('newYear', year.title);
    } else {
      localStorage.setItem('selectedYear', year.title);
    }
    this.router.navigate(['variant']);
  }

  goToModel() {
    this.router.navigate(['model']);
  }
}
